import React, { useState } from 'react';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import { useField, useFormikContext } from 'formik';
import { FormHelperText, FormLabel, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box } from '@mui/system';
import { InfoDialog } from '../../components/investors/components';

interface MultiSelectCheckboxProps {
  name: string;
  options: { key: string; value: string; info?: string }[];
  selectedValues: string[];
  formLabel?: string;
  labelColor?: string;
  onChange?: (newSelectedValues: string) => void;
  disabled?: boolean;
}

function MultiSelectCheckbox({
  name,
  options,
  selectedValues,
  onChange,
  formLabel,
  labelColor,
  disabled = false,
}: MultiSelectCheckboxProps): JSX.Element {
  const [field, meta] = useField(name);
  const errorText = meta.error && meta.touched ? meta.error : '';
  const { setFieldValue } = useFormikContext();
  const handleCheckboxChange = (value: string) => {
    const index = (selectedValues || []).indexOf(value as string);
    if (index === -1) {
      setFieldValue(name, [...(field.value || []), value]);
    } else {
      setFieldValue(
        name,
        (field.value || []).filter((item: any) => item != (value as string))
      );
    }
  };

  const [dialogMessage, setDialogMessage] = useState({ message: '', title: '' });
  const [open, setOpen] = useState(false);
  const handleOpen = ({ message, title }: { message: string; title: string }) => {
    setOpen(true), setDialogMessage({ message, title });
  };
  const handleClose = () => {
    setOpen(false);
    setDialogMessage({ message: '', title: '' });
  };
  return (
    <FormGroup>
      {formLabel && (
        <FormLabel
          component="legend"
          sx={{ mb: 2, fontWeight: 500, fontSize: 14, color: labelColor }}>
          {formLabel}
        </FormLabel>
      )}
      {options.map((option, index) => (
        <Box key={index} sx={{ display: 'flex', flexDirection: 'row' }}>
          <FormControlLabel
            key={option.key}
            value={option.key}
            control={
              <Checkbox
                disabled={disabled}
                onChange={() =>
                  onChange ? onChange(option.key) : handleCheckboxChange(option.key)
                }
                checked={(selectedValues || []).includes(option.key)}
              />
            }
            label={option.value}
          />
          {option?.info && (
            <Typography component="span" sx={{ position: 'relative', left: -15, bottom: -10 }}>
              <InfoOutlinedIcon
                color="info"
                fontSize="small"
                onClick={() => handleOpen({ message: option?.info || '', title: option.value })}
              />
            </Typography>
          )}
        </Box>
      ))}
      <InfoDialog
        onClose={handleClose}
        open={open}
        content={dialogMessage.message}
        // title={dialogMessage.title}
        // infoIcon={false}
      />
      {errorText && (
        <FormHelperText error sx={{ marginLeft: 'unset' }}>
          {errorText}
        </FormHelperText>
      )}
    </FormGroup>
  );
}

export default MultiSelectCheckbox;
